const SfdcAccountName = ({ name }: { name?: string | null }) => {
  if (!name) {
    return null
  }
  return (
    <span
      className='text-xs text-muted-foreground'
      title={`Salesforce: ${name}`}
    >
      SF: {name}
    </span>
  )
}

export default SfdcAccountName
